import Vue from 'vue';

export default [
    {
        pathId: 'tl',
        component: 'task-list',
        title: 'Tasks',
        icon: 'fa-tasks',
        size: 'sm',
        reload: true
    }, {
        pathId: 'tn',
        component: 'task-new',
        title: 'New Task',
        icon: 'fa-tasks',
        size: 'md'
    }
];

Vue.component('task-list', () => import('@/cards/tasks/TaskList'));
Vue.component('task-new', () => import('@/cards/tasks/TaskNew'));
